var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-details-container",class:( _obj = {}, _obj[("theme-" + _vm.theme)] = _vm.theme, _obj )},[_c('ContainerMedium',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }